import { render } from "./carruselultimo_ingles.vue?vue&type=template&id=1b50f3de&scoped=true"
import script from "./carruselultimo_ingles.vue?vue&type=script&lang=js"
export * from "./carruselultimo_ingles.vue?vue&type=script&lang=js"

import "./carruselultimo_ingles.vue?vue&type=style&index=0&id=1b50f3de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b50f3de"]])

export default __exports__